import React from 'react';
import { YStack } from '@tamagui/stacks';
import { Text } from '@tamagui/core';
import { COLORS } from '@/constants/colors';

type DateSeparatorProps = {
  date: string;
  isDark?: boolean;
};

const DateSeparator = React.memo<DateSeparatorProps>(({ date, isDark }) => {
  const textColor = isDark ? COLORS.GRAY_400 : COLORS.GRAY_500;
  const bgColor = isDark ? COLORS.ZINC_900 : '#E5E5EA';

  return (
    <YStack alignItems="center" paddingVertical="$3">
      <YStack
        paddingHorizontal="$3"
        paddingVertical="$1"
        borderRadius={12}
        backgroundColor={bgColor}
      >
        <Text fontSize={12} color={textColor} fontWeight="500">
          {date}
        </Text>
      </YStack>
    </YStack>
  );
});

DateSeparator.displayName = 'DateSeparator';

export default DateSeparator;


